var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DhCtaComponent"},[_c('chevron-section',{attrs:{"colorHex":"#fe5000","top":""}},[_c('wrapper-responsive-center',[_c('div',{staticClass:"white--text"},[_vm._t("default")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }